import { render } from "./PlayerForm.vue?vue&type=template&id=45a9e18e"
import script from "./PlayerForm.vue?vue&type=script&lang=js"
export * from "./PlayerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__